import { createContext, useContext, useState, useEffect } from 'react';
import i18n from 'i18next';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(i18n.language || 'ar');
  const [isRTL, setIsRTL] = useState(language === 'ar' || language === 'he');

  useEffect(() => {
    const rtl = language === 'ar' || language === 'he';
    setIsRTL(rtl);
    i18n.changeLanguage(language);
    // Must derive from `language` — not `isRTL` — or the first run can set the wrong dir
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  const value = {
    language,
    isRTL,
    changeLanguage,
    t: (key, options) => i18n.t(key, options),
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

